import { ProductKeys } from '../constants/product-keys';

export const isJiraProduct: (product?: ProductKeys, includeDC?: boolean) => boolean = (
	product?: ProductKeys,
	includeDC = false,
): boolean => {
	const jiraProducts = includeDC
		? ([
				ProductKeys.Jira,
				ProductKeys.JiraDC,
				ProductKeys.JiraProductDiscovery,
				ProductKeys.JiraServiceManagement,
				ProductKeys.CustomerServiceManagement,
			] satisfies ProductKeys[])
		: ([
				ProductKeys.Jira,
				ProductKeys.JiraProductDiscovery,
				ProductKeys.JiraServiceManagement,
				ProductKeys.CustomerServiceManagement,
			] satisfies ProductKeys[]);

	return Boolean(jiraProducts.find((jiraProduct) => jiraProduct === product));
};
